// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18ZMT","left":"styles_left__2JfdN"};